import { Form } from 'factorial-form'

class WorkAreaForm extends Form {
  constructor(values: Record<string, any>) {
    super(values, {
      name: 'string',
      location_id: 'string',
    })
  }
}

export default WorkAreaForm
